module.exports = __webpack_public_path__ + "img/projects_per_country_recent.bf01d20c.png";